<template>
  <div class="personal">
    <div class="w">
      <el-container class="full">
        <el-aside width="13.75rem" style="min-width: 180px">
          <el-card>
            <el-menu
              :default-active="store.path"
              class="el-menu-vertical-demo"
              background-color="#fff"
              text-color="#000"
              router
              active-text-color="rgb(67, 188, 183)"
              active-background-color="rgb(67, 188, 183)"
            >
              <el-menu-item index="1" route="/personal/acc">
                <span slot="title">{{ $t("personal.zhanghu") }} </span>
                <span class="fr">></span>
              </el-menu-item>
              <el-menu-item index="2" route="/personal/order">
                <span slot="title">{{ $t("personal.dingdan") }}</span>
                <span class="fr">></span>
              </el-menu-item>
              <el-menu-item index="3" route="/personal/car">
                <span slot="title">{{ $t("personal.gouwuche") }}</span>
                <span class="fr">></span>
              </el-menu-item>
              <el-menu-item index="4" route="/personal/pwd">
                <span slot="title">{{ $t("personal.anquan") }}</span>
                <span class="fr">></span>
              </el-menu-item>
              <el-menu-item index="5" route="/personal/msg">
                <span slot="title">{{ $t("personal.xiaoxi") }}</span>
                <span class="fr">></span>
              </el-menu-item>
            </el-menu>
          </el-card>
        </el-aside>
        <el-main class="pr-none main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import Store from "../store";
export default {
  data() {
    return {
      store: Store.state,
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.main {
  padding: 1.25rem 0 0 1.25rem;
}
.el-menu-item {
  > span {
    &:last-child {
      max-width: 8rem;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.personal {
  min-height: 50rem;
  .el-aside {
    padding-top: 1.25rem;
    .el-menu {
      border: none;
    }
  }
}
</style> 